import { AuthRole } from '@bechtel/types';
import { map } from 'lodash';

/**
 * Utility function to get the role display text from user roles
 * Returns "Craft" if user has multiple roles, otherwise returns the single role name
 */
export const getPriorityRoleKey = (roles: AuthRole[]): string => {
  if (!roles || roles.length === 0) {
    return '';
  }

  // If user has only one role, return its name
  if (roles.length === 1) {
    return roles[0].name;
  }

  // If user has multiple roles, return all the roles
  return map(roles, role => role.name).join(', ');
};
